import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:col-span-1 flex flex-col"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "relative mt-2 rounded-md shadow-sm" }
const _hoisted_4 = ["type", "name", "id", "placeholder"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 1,
  class: "sm:col-span-1"
}
const _hoisted_8 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 2,
  class: "w-full"
}
const _hoisted_11 = { class: "flex items-baseline gap-2" }
const _hoisted_12 = {
  class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1",
  for: "name"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "relative w-full" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["id", "placeholder", "required", "disabled"]
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "relative z-50" }
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]

import { ref, shallowRef } from "vue";
import { defineEmits } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
// import { default } from '../../store/modules/notificationStore';

export default /*@__PURE__*/_defineComponent({
  __name: 'InputTextWithHelpLink',
  props: {
  model: {
    required: false,
  },
  type: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  admin: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
let model = shallowRef(props.model as dtos.DynamicProperty);

function customChange(event: any) {
  emit("change", model.value);
}

return (_ctx: any,_cache: any) => {
  return (props.adminView && props.editMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          for: _unref(model).label,
          class: "text-sm font-medium text-gray-500"
        }, _toDisplayString(_unref(model).label), 9, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: props.type || 'text',
            name: _unref(model).label,
            id: _unref(model).key,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).data) = $event)),
            class: "p-2 block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 focus:outline-none sm:text-sm sm:leading-6",
            placeholder: _unref(model).placeholder
          }, null, 8, _hoisted_4), [
            [_vModelDynamic, _unref(model).data]
          ]),
          _createElementVNode("div", {
            class: "hidden pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3",
            id: 'icon-error_' + _unref(model).key
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fas fa-exclamation-circle text-red-500",
              "aria-hidden": "true"
            }, null, -1)
          ]))], 8, _hoisted_5)
        ]),
        _createElementVNode("p", {
          id: 'error_' + _unref(model).key,
          class: "mt-2 text-sm text-red-600"
        }, null, 8, _hoisted_6)
      ]))
    : (__props.adminView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("dt", _hoisted_8, _toDisplayString(_unref(model).label || "LinkedIn"), 1),
          _createElementVNode("a", {
            as: "a",
            href: _unref(model).data,
            target: "_blank",
            class: "mt-1 text-sm text-blue-600 hover:text-blue-500"
          }, [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Öppna ", -1),
            _createElementVNode("i", { class: "fas fa-external-link-alt ml-1" }, null, -1)
          ]))], 8, _hoisted_9)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(model).label), 1),
            _createElementVNode("a", {
              href: _unref(model).placeholder,
              target: "_blank"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", {
                class: "text-darkGray-1 fa-solid fa-circle-question text-xs",
                title: "Öppna guide i ny flik"
              }, null, -1)
            ]))], 8, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (props.disabled && props.admin)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _unref(model).data,
                  target: "_blank",
                  class: _normalizeClass(
          _unref(model)?.data && _unref(model)?.data?.length > 0
            ? 'text-blue-1 hover:underline'
            : 'text-darkGray-2 pointer-events-none'
        )
                }, _toDisplayString(_unref(model)?.data && _unref(model)?.data?.length > 0
            ? "Öppna länk i ny flik"
            : "länk saknas"), 11, _hoisted_15))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  onInput: customChange,
                  class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed relative",
                  id: _unref(model).key,
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).data) = $event)),
                  placeholder: _unref(model).label,
                  required: props.required ? true : null,
                  disabled: props.disabled ? true : null
                }, null, 40, _hoisted_16)), [
                  [_vModelText, _unref(model).data]
                ]),
            _createElementVNode("div", {
              id: 'icon-error_' + _unref(model).key,
              class: "hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center",
              onMouseenter: showErrorMessage,
              onMouseleave: hideErrorMessage
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
            ]))], 40, _hoisted_17)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
              id: 'outer-error_' + _unref(model).key
            }, [
              _createElementVNode("p", {
                class: "font-medium text-sm text-red-2",
                id: 'error_' + _unref(model).key
              }, null, 8, _hoisted_20)
            ], 8, _hoisted_19)
          ], 512), [
            [_vShow, showingErrorMessage.value]
          ])
        ]))
}
}

})